import Table from "../../../../src/content/blog/science-with-science-gothic/table.js";
import React from 'react';
export default {
  Table,
  React
};